module.exports = __webpack_public_path__ + "static/media/our_platform_is_domain_agnostic_bg.87b3412b.png";